export default function PrimaryButton({buttonText, clickHandler}) {
	return (
		<>
			<button type="button" onClick={clickHandler} className="btn btn-primary m-5">
				{buttonText}
			</button>
		</>
	);
}